// Models
import { getFlatEntities } from 'utils/helperMethods';
import DashBoardData from '../models/dashBoardData';

import {
    FETCH_MIXED_GRAPH_SUCCESS,
    FETCH_MIXED_GRAPH_ERROR,
    FETCH_MULTI_GRAPH_SUCCESS,
    FETCH_MULTI_GRAPH_ERROR,
    FETCH_SINGLE_SUCCESS,
    FETCH_SINGLE_ERROR,
    FETCH_DASHBOARD_SUMMARY_REQUEST,
    FETCH_DASHBOARD_SUMMARY_SUCCESS,
    FETCH_DASHBOARD_SUMMARY_ERROR,
    SHOW_DASHBOARD_LOADER,
    HIDE_DASHBOARD_LOADER,
    RESET_DASHBOARD_REQUEST,
    FETCH_MULTI_ENTITY_HIERARCHY_SUCCESS,
    FETCH_MULTI_ENTITY_HIERARCHY_ERROR,
} from './dashboard.constants';

const initialState = {
    failures: {},
    paymentModeWise: {},
    entityList: {},
    singleGraph: {
        GMV: {},
        STATUS_TREND: {},
        SUCCESS_RATE: {},
        TRANSACTIONS_COUNT: {},
    },
    summary: {
        isLoading: false,
    },
    error: {},
    isLoading: false,
};

export const dashBoardReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_MIXED_GRAPH_SUCCESS: {
            return {
                ...state,
                failures: { ...action.payload },
                error: {},
            };
        }
        case FETCH_MIXED_GRAPH_ERROR: {
            return {
                ...state,
                failures: {},
                error: { ...action.payload },
            };
        }

        case FETCH_MULTI_GRAPH_SUCCESS: {
            return {
                ...state,
                paymentModeWise: { ...action.payload },
                error: {},
            };
        }
        case FETCH_MULTI_GRAPH_ERROR: {
            return {
                ...state,
                paymentModeWise: {},
                error: { ...action.payload },
            };
        }
        case FETCH_SINGLE_SUCCESS: {
            return {
                ...state,
                singleGraph: {
                    ...state.singleGraph,
                    [action.payload.graphIdentifier]: {
                        granularity: action.payload.data.granularity,
                        timeSeriesValues:
                            action.payload.data.values[
                                action.payload.graphIdentifier
                            ],
                    },
                },
                error: {},
            };
        }
        case FETCH_SINGLE_ERROR: {
            return {
                ...state,
                singleGraph: {},
                error: { ...action.payload },
            };
        }
        case FETCH_DASHBOARD_SUMMARY_REQUEST: {
            return {
                ...state,
                summary: { isLoading: true },
                error: {},
            };
        }
        case FETCH_DASHBOARD_SUMMARY_SUCCESS: {
            return {
                ...state,
                summary: { isLoading: false, ...action.payload },
                error: {},
            };
        }
        case FETCH_DASHBOARD_SUMMARY_ERROR: {
            return {
                ...state,
                summary: {
                    isLoading: false,
                },
                error: { ...action.payload },
            };
        }
        case RESET_DASHBOARD_REQUEST: {
            return {
                ...initialState,
                error: {},
            };
        }
        case FETCH_MULTI_ENTITY_HIERARCHY_SUCCESS: {
            const flatEntities = getFlatEntities(
                action.payload,
                action.entityType
            );
            const entities = { ...state.entityList, ...flatEntities };
            return { ...state, entityList: entities };
        }

        case FETCH_MULTI_ENTITY_HIERARCHY_ERROR: {
            return { ...state, entityList: { ...action.payload } };
        }
        case SHOW_DASHBOARD_LOADER:
            return { ...state, isLoading: true };
        case HIDE_DASHBOARD_LOADER:
            return { ...state, isLoading: false };
        default:
            return state;
    }
};
